import { render, staticRenderFns } from "./TablePostponed.vue?vue&type=template&id=4aab97f9"
import script from "./TablePostponed.vue?vue&type=script&lang=js"
export * from "./TablePostponed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports